// extracted by mini-css-extract-plugin
export var copyableField = "_pu-4";
export var customerBadge = "_pu-0";
export var customerInfoTitle = "_pu-2";
export var details = "_pu-1";
export var dropdownContainer = "_pu-5";
export var dropdownImage = "_pu-6";
export var editAssigneeForm = "_pu-a";
export var editButton = "_pu-3";
export var email = "_pu-7";
export var hidden = "_pu-d";
export var input = "_pu-8";
export var saveButton = "_pu-b";
export var shopifyIcon = "_pu-c";
export var suggestionBadge = "_pu-e";
export var suggestionText = "_pu-f";
export var username = "_pu-9";